const addToCartUrl = _.get(window, 'mageglobal.uc.carturl');
const schoolCode = document.getElementById('uc-loader').getAttribute('data-school-code');
const itemID = document.getElementById('uc-loader').getAttribute('data-jcp-item-id');
const magentoSku = document.getElementById('uc-loader').getAttribute('data-magento-sku');
const configId = _.get(window, 'mageglobal.uc.config_id');
const shopperID = _.get(document.cookie.match(new RegExp('(^| )DPOrder=([^;]+)')), [2]) || '';

const JcpLoader = {
  addToCartUrl,
  schoolCode,
  itemID,
  magentoSku,
  configId,
  shopperID,
};

export default JcpLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/jcp.js